module.exports = __webpack_public_path__ + "img/aegraphics_logo.b948f60b.png";